import Vue from 'vue';
import Router from 'vue-router';
import path from 'path-browserify';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'homepage',
      component: () => import('./views/homepage'),
    },
    {
      path: '/documentation',
      component: () => import('./views/documentation'),
      children: require.context('./views/documentation/', true, /\.vue$/).keys().map(doc => {
        const pathObj = path.parse(doc);
        const dir = pathObj.dir.split('.').pop();
        const name = pathObj.name;
        return {
          path: path.join('/documentation', dir, name === 'index' ? '' : name),
          component: () => import(`./views/documentation${dir}/${name}`),
        };
      }),
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return savedPosition ||  { x: 0, y: 0 };
  },
});

